<template>
  <div>
  </div>
</template>

<script>
  export default {
    mounted () {
      this.auth()
    },
    methods: {
      auth () {
        localStorage.removeItem('token')
        localStorage.removeItem('type')
        localStorage.removeItem('admin')
        this.$http.post('/get-session', {
          'token': this.$route.params.token
        }).then((response) => {
          if (response.data.user) {
            localStorage.setItem('token', response.data.user.token)
            localStorage.setItem('type', response.data.user.type)
            localStorage.setItem('admin', true)
            this.$router.push('/organization/profile')
          } else {
            this.$router.push('/auth/login')
          }
        })
          .catch((error) => {
            console.log(error)
            this.$router.push('/auth/login')
          })
      }
    }
  }
</script>